import { GenericService } from '../../../../core/services/GenericService';
import { Injectable } from '@angular/core';
import { ApiService } from '../../../../core/services';
import { ISupplier } from '../interfaces/ISupplier';
import { Observable } from 'rxjs';
import { ISimpleListItem } from '../../../../core/interfaces/ISimpleListItem';
import { HttpParams } from '@angular/common/http';
import { IAssignSupplierArticlesResult } from '../interfaces/IAssignSupplierArticlesResult';

@Injectable({
  providedIn: 'root'
})
export class SuppliersService extends GenericService<ISupplier>{
  protected readonly baseUrl = '/suppliers';

  constructor(public apiService: ApiService) {
    super(apiService);
  }

  getSimpleList( search = ''): Observable<ISimpleListItem[]> {
    const params = new HttpParams()
      .append('search', `${search}`)
      .append('results', 10000);
    return this.apiService.get(`${this.baseUrl}/simple`, params);
  }

  assignArticles(supplierId: number, articleIds: number[], confirmMove: boolean): Observable<IAssignSupplierArticlesResult> {
    return this.apiService.post(`${this.baseUrl}/${supplierId}/articles`, { articleIds, confirmMove });
  }

  unassignArticle(supplierId: number, articleId: number): Observable<void> {
    return this.apiService.delete(`${this.baseUrl}/${supplierId}/articles/${articleId}`);
  }
}
